$(document).ready(function(){

    var lazyWin = $(window), loadChat = false;
    
    var lazyChat = function(){
        if(!yebalok.urlContains("/travel-guide") && !loadChat){
            
            window.__lc = window.__lc || {};
            window.__lc.license = 9521600;
            window.__lc.group = 1;
            
            window.LC_API = window.LC_API || {};
            window.LC_API.on_before_load = function(){
                if(window.LC_API.agents_are_available()){
                    $('.collapsible-inquire-box').remove();
                    $('.mobile-inquire-btn').remove();
                } else {
                    window.LC_API.hide_chat_window();
                    $('#livechat-compact-container').css('z-index', '200');
                }
            };
            
            (function() {
                var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
                lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
            })();
            
            //send chat to bpm 
            LC_API.on_chat_started = function(data){
                
                var userData = {}
                
                userData['chatId']              = LC_API.get_chat_id();
                userData['UsrGoogleClickId']    = getCookie('_ga');
                userData['UsrSourceValue']      = getCookie('roasurl');
                userData['UsrProductCode']      = 'PAN-CHAT-1';
                userData['UsrProdCategory']     = 'travel-guide';
                userData['UsrProdType']         = 'chat';
                userData['UsrProductName']      = document.title;
                userData['UsrInquiryForm']      = 'Live Chat';
                
                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    type: "POST",
                    data: {
                        action: 'sent_bpm',
                        'userData': userData
                    },
                    success: function(data) {
                        console.log(data);
                    }
                });
            }
            
            loadChat = true;
        }
    };
    
    var lazyLoadImage = function(element, src){
        if(src){
            var newImg = new Image;
            newImg.onload = function() {
                element.attr("src", this.src).addClass('lazyloaded').removeAttr('data-src');
            }
            newImg.src = src;
        }
    };

    var lazyLoadBgImage = function(element, src){
        if(src){
            var newImg = new Image;
            newImg.onload = function() {
                element.css("background-image", 'url("'+this.src+'")').addClass('lazyloaded').removeAttr('data-src');
            }
            newImg.src = src;
        }
    };

    var lazyLoadFrame = function(element, src){
        if(src){
            element.attr('src', src).addClass('lazyloaded').removeAttr('data-src');
        }
    };

    var lazyLoadYoutube = function(element, youtubeId){
        if(youtubeId){
            element.addClass('lazyloaded');
            var iframeHTML = "<iframe src='https://www.youtube.com/embed/" + youtubeId + "?autoplay=1' frameborder='0' allowfullscreen='1'></iframe>";
            if(yebalok.isMobile()){
                showYoutubeIframe(element, youtubeId);
            }
            else{
                var youtubeImg = new Image,
                    imgSrc = "https://img.youtube.com/vi/" + youtubeId + "/maxresdefault.jpg";

                youtubeImg.onload = function() {
                    element.css("background-image", "url(" + imgSrc + ")").removeAttr('data-src').click(function(){
                        showYoutubeIframe(element, youtubeId);
                    });
                }
                youtubeImg.src = imgSrc;
            }
        }
    };

    var showYoutubeIframe = function(element, youtubeId){
        var iframeHTML = "<iframe src='https://www.youtube.com/embed/" + youtubeId + "?autoplay=1' frameborder='0' allowfullscreen='1'></iframe>";
        element.append(iframeHTML).css("background-image", "").addClass('lazyloaded');
        element.find(".play").fadeOut(500);
        element.find(".youtube-title").fadeOut(500);
    };

    var lazyUpdateLinks = function(){
        $('a').each(function() {
            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href)) {
                $(this).attr("target", "_blank");
            }
        });
    };
    
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length,c.length);
            }
        }
        return false;
    }

    var loadLazyElements = function(){

        var lazyImages = $("img.lazy").not('.lazyloaded'),
            lazyFrames = $("iframe.lazy").not('.lazyloaded'),
            lazyBg = $(".lazy-bg").not('.lazyloaded'),
            youtubeFrames = $(".youtube-lazy").not('.lazyloaded');

        //lazyload images
        if(lazyImages.length > 0){
            lazyImages.each(function(i, e) {
                var element = $(e),
                    imgSrc = element.data("src");
                lazyLoadImage(element, imgSrc);
            });
        }

        //lazyload frames
        if(lazyFrames.length > 0){
            lazyFrames.each(function(i, e) {
                var element = $(e),
                    frameSrc = element.data("src");
                lazyLoadFrame(element, frameSrc);
            });
        }

        //lazyload bg images
        if(lazyBg.length > 0){
            lazyBg.each(function(i, e) {
                var element = $(e),
                    imgSrc = element.data("src");
                lazyLoadBgImage(element, imgSrc);
            });
        }

        //lazyload youtube elements
        //<iframe class="youtube-lazy" data-src="https://www.youtube.com/embed/IorUlBnXMy0" frameborder="0" allowfullscreen></iframe>
        if(youtubeFrames.length > 0){
            youtubeFrames.each(function(i, e) {
                var element = $(e),
                    youtubeId = element.data("src");
                lazyLoadYoutube(element, youtubeId);
            });
        }

        //checks external links on the page
        lazyUpdateLinks();
        
        //loadchat
        lazyChat();
    };

    lazyWin.scroll(function(event){
        loadLazyElements();
    });

    lazyWin.mousemove(function(event){
        loadLazyElements();
    });
});




// WEBPACK FOOTER //
// ./js/partials/lazy.js